/* eslint-disable */
import Swiper, { Navigation } from "swiper";
import 'particles.js';


export default {
  init() {

    if($('.tour').length > 0) {
        $('.tour').closest('.l-container').removeClass('l-container--m')
    };

    if($('#particles-js').length > 0) {
      const windowMobile = window.innerWidth < 520
      const windowTablet = window.innerWidth > 520 && window.innerWidth < 1024
      particlesJS('particles-js',{
        "particles": {
          "number": {
            "value": windowMobile ? 100 : windowTablet ? 150 : 200,
            "density": {
              "enable": false,
              "value_area": 1100
            }
          },
          "color": {
            "value": "#ffffff"
          },
          "shape": {
            "type": "circle",
            "stroke": {
              "width": 0,
              "color": "#000000"
            },
            "polygon": {
              "nb_sides": 5
            },
            "image": {
              "src": "img/github.svg",
              "width": 100,
              "height": 100
            }
          },
          "opacity": {
            "value": 0.5,
            "random": true,
            "anim": {
              "enable": true,
              "speed": 1,
              "opacity_min": 0.1,
              "sync": false
            }
          },
          "size": {
            "value": 4,
            "random": true,
            "anim": {
              "enable": true,
              "speed": 3,
              "size_min": 0.1,
              "sync": false
            }
          },
          "line_linked": {
            "enable": true,
            "distance": 200,
            "color": "#ffffff",
            "opacity": 0.4,
            "width": 1
          },
          "move": {
            "enable": true,
            "speed": 0.4,
            "direction": "top",
            "random": false,
            "straight": false,
            "out_mode": "out",
            "bounce": false,
            "attract": {
              "enable": false,
              "rotateX": 600,
              "rotateY": 1200
            }
          }
        },
        "interactivity": {
          "detect_on": "canvas",
          "events": {
            "onhover": {
              "enable": true,
              "mode": "repulse"
            },
            "onclick": {
              "enable": true,
              "mode": "push"
            },
            "resize": true
          },
          "modes": {
            "grab": {
              "distance": 400,
              "line_linked": {
                "opacity": 1
              }
            },
            "bubble": {
              "distance": 400,
              "size": 40,
              "duration": 2,
              "opacity": 8,
              "speed": 3
            },
            "repulse": {
              "distance": 25,
              "duration": 2.9
            },
            "push": {
              "particles_nb": 4
            },
            "remove": {
              "particles_nb": 2
            }
          }
        },
        "retina_detect": true
      }, function() {
      });
    }

    if(document.querySelector('.o-external-link')) {
      window.location.replace($('.o-external-link').attr('data-external'));
    }

    // http://stackoverflow.com/a/11381730/989439
    const mobilecheck = function () {
      let check = false;
      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    };

    if ($(".js-show-more-button")) {
      $(".js-show-more-button").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(".js-show-more-container").toggleClass("open");
        $(this)
          .find("a")
          .text($(this).find("a").text() == "Close" ? "Show more" : "Close");
      });
    }

    $('.js-tab-content:not(".is-active")').hide();
    document.querySelectorAll(".js-tabs").forEach((tabs) => {
      tabs.querySelectorAll(".js-tab").forEach((element) => {
        element.addEventListener("click", (e) => {
          e.preventDefault();
          var tab_id = element.getAttribute("data-tab");
          var tab = tabs.querySelector("#" + tab_id);

          tabs.querySelectorAll(".js-tab, .js-tab-content").forEach((el) => {
            el.classList.remove("is-active");
          });

          element.classList.add("is-active");
          $(".js-tab-content:not(.is-active)").fadeOut();
          if (tab) {
            $(tab).delay(500).fadeIn();
            tab.classList.add("is-active");
          }
        });
      });
    });

    /**
     * General helper function to support toggle functions.
     */
    var toggleClasses = function (element) {
      var $this = element,
        $togglePrefix = $this.data("prefix") || "this";

      // If the element you need toggled is relative to the toggle, add the
      // .js-this class to the parent element and "this" to the data-toggled attr.
      if ($this.data("toggled") == "this") {
        var $toggled = $this.closest(".js-this");
      } else {
        var $toggled = $("." + $this.data("toggled"));
      }
      if ($this.attr("aria-expanded", "true")) {
        $this.attr("aria-expanded", "true");
      } else {
        $this.attr("aria-expanded", "false");
      }
      $this.toggleClass($togglePrefix + "-is-active");
      $toggled.toggleClass($togglePrefix + "-is-active");

      // Remove a class on another element, if needed.
      if ($this.data("remove")) {
        $("." + $this.data("remove")).removeClass($this.data("remove"));
      }
    };

    /*
     * Toggle Active Classes
     *
     * @description:
     *  toggle specific classes based on data-attr of clicked element
     *
     * @requires:
     *  'js-toggle' class and a data-attr with the element to be
     *  toggled's class name both applied to the clicked element
     *
     * @example usage:
     *  <span class="js-toggle" data-toggled="toggled-class">Toggler</span>
     *  <div class="toggled-class">This element's class will be toggled</div>
     *
     */
    $(".js-toggle").on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggleClasses($(this));
    });

    // Toggle parent class
    $(".js-toggle-parent").on("click", function (e) {
      e.preventDefault();
      var $this = $(this);
      $this.toggleClass("this-is-active");
      $this.parent().toggleClass("this-is-active");
    });

    $(".js-prevent-scroll").on("click", function (e) {
      e.preventDefault();
      var $this = $("body");
      $this.toggleClass("u-prevent-scroll");
    });

    // Prevent bubbling to the body. Add this class to the element (or element
    // container) that should allow the click event.
    $(".js-stop-prop").on("click", function (e) {
      e.stopPropagation();
    });

    // Toggle hovered classes
    $(".js-hover").on("mouseenter mouseleave", function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggleClasses($(this));
    });

    $(".js-hover-parent").on("mouseenter mouseleave", function (e) {
      e.preventDefault();
      var $this = $(this);
      $this.toggleClass("this-is-active");
      $this.parent().toggleClass("this-is-active");
    });

    /**
     * Remove .o-block spacing with below full width components
     */
    $(".c-block-side-by-side, .c-block-testimonial--large")
      .parent(".o-block")
      .addClass(
        "u-spacing-negative--zero--bottom u-spacing-negative--zero--top"
      );

    /**
     * Accordion
     */
    $(".js-toggle-accordion").click(function (e) {
      e.preventDefault();
      const $button = $(this);
      const currentState = $button.attr('aria-expanded');
      const newState = currentState === 'true' ? 'false' : 'true';
      
      $button
        .toggleClass("active")
        .attr('aria-expanded', newState)
        .next(".c-block--accordion__content")
        .slideToggle();
        
      $button.find(".u-plus").toggleClass("open");
    });

    // Mobile Hamburger
    $(".js-mobile-menu").click(function (e) {
      e.preventDefault();
      $(this).toggleClass("is-active");
      $(".c-menu--mobile").toggleClass("is-active-until-m");
      $("body").toggleClass("is-no-scroll-until--m c-menu--mobile--active");
    });

    /**
     * Mobile Navigation Accordion
     */
    $(".js-toggle-sub-menu").click(function (e) {
      e.preventDefault();
      $(this)
        .toggleClass("active")
        .next(".c-menu--mobile--sub-menu")
        .slideToggle();
      $(this).find(".u-plus").toggleClass("open");
    });

    /**
     * Test Plus/Minus
     */
    $(".js-toggle-plus").click(function (e) {
      e.preventDefault();
      $(this).toggleClass("open");
    });

    // var sticky_navigation = function () {
    //   $("body").toggleClass("traveling", $(window).scrollTop() > 100);
    // };

    // $(window).on("scroll", () => {
    //   e.preventDefault();
    //   sticky_navigation;
    // });
    // sticky_navigation();

    function randomIntFromInterval(min, max) { // min and max included
      return Math.floor(Math.random() * (max - min + 1) + min)
    }

    if ($(".ani-circle").length > 0) {
      var fadeInOut = gsap.timeline({repeat:-1});

      fadeInOut.to('.ani-circle', {
        alpha: 0.7,
        scale: 0.8,
        duration: randomIntFromInterval(4, 9),
        ease: "power4.in",
        stagger: {
          each: 1,
          repeat:1,
          yoyo:true,
          yoyoEase:true
        }
      })
    };

    gsap.registerPlugin(ScrollTrigger);
    if ($(".o-hero__chapter").length > 0) {
      gsap.set(".c-block-hero--chapter1 h1", { alpha: 0, x: 20 });
      gsap.set(".c-block-hero--chapter1 .o-rte-text", { alpha: 0, x: -20 });
      if (
        $(".c-block-hero--chapter1 .c-block-split__link-wrapper").length > 0
      ) {
        gsap.set(".c-block-hero--chapter1 .c-block-split__link-wrapper", {
          alpha: 0,
          y: 20,
        });
      }

      gsap.set(".c-block-hero--chapter2 h1", { alpha: 0, x: -20 });
      gsap.set(".c-block-hero--chapter2 .o-rte-text", { alpha: 0, x: 20 });
      if (
        $(".c-block-hero--chapter2 .c-block-split__link-wrapper").length > 0
      ) {
        gsap.set(".c-block-hero--chapter2 .c-block-split__link-wrapper", {
          alpha: 0,
          y: 20,
        });
      }

      gsap.set(".c-block-hero--chapter3 h1", { alpha: 0, x: 20 });
      gsap.set(".c-block-hero--chapter3 .o-rte-text", { alpha: 0, x: -20 });
      if (
        $(".c-block-hero--chapter3 .c-block-split__link-wrapper").length > 0
      ) {
        gsap.set(".c-block-hero--chapter3 .c-block-split__link-wrapper", {
          alpha: 0,
          y: 20,
        });
      }

      gsap.set(".o-hero__chapter img", {
        filter: "grayscale(100%)",
        "-webkit-filter": "grayscale(100%)",
        skewX: 1,
      });

      gsap.to(".c-block-hero--chapter1 h1", {
        scrollTrigger: {
          trigger: ".c-block-hero--chapter1 h1",
          start: "top 90%",
        },
        alpha: 1,
        x: 0,
        ease: "none",
        duration: 0.5,
      });
      gsap.to(".c-block-hero--chapter1 .o-rte-text", {
        scrollTrigger: {
          trigger: ".c-block-hero--chapter1 .o-rte-text",
          start: "top 90%",
        },
        alpha: 1,
        x: 0,
        ease: "none",
        duration: 0.5,
      });
      if (
        $(".c-block-hero--chapter1 .c-block-split__link-wrapper").length > 0
      ) {
        gsap.to(".c-block-hero--chapter1 .c-block-split__link-wrapper", {
          scrollTrigger: {
            trigger: ".c-block-hero--chapter1 .c-block-split__link-wrapper",
            start: "top 90%",
          },
          alpha: 1,
          y: 0,
          ease: "none",
          duration: 0.5,
          delay: 0,
        });
      }

      gsap.to(".c-block-hero--chapter1 img", {
        scrollTrigger: {
          trigger: ".c-block-hero--chapter1 img",
          start: "top 90%",
        },
        filter: "grayscale(0%)",
        "-webkit-filter": "grayscale(0%)",
        skewX: 0,
        ease: "none",
        duration: 0.5,
        delay: 0,
      });

      gsap.to(".c-block-hero--chapter2 h1", {
        scrollTrigger: {
          trigger: ".c-block-hero--chapter2 h1",
          start: "top 90%",
        },
        alpha: 1,
        x: 0,
        ease: "none",
        duration: 0.5,
      });
      gsap.to(".c-block-hero--chapter2 .o-rte-text", {
        scrollTrigger: {
          trigger: ".c-block-hero--chapter2 .o-rte-text",
          start: "top 90%",
        },
        alpha: 1,
        x: 0,
        ease: "none",
        duration: 0.5,
      });
      if (
        $(".c-block-hero--chapter2 .c-block-split__link-wrapper").length > 0
      ) {
        gsap.to(".c-block-hero--chapter2 .c-block-split__link-wrapper", {
          scrollTrigger: {
            trigger: ".c-block-hero--chapter2 .c-block-split__link-wrapper",
            start: "top 90%",
          },
          alpha: 1,
          y: 0,
          ease: "none",
          duration: 0.5,
          delay: 0,
        });
      }
      gsap.to(".c-block-hero--chapter2 img", {
        scrollTrigger: {
          trigger: ".c-block-hero--chapter2 img",
          start: "top 90%",
        },
        filter: "grayscale(0%)",
        "-webkit-filter": "grayscale(0%)",
        skewX: 0,
        ease: "none",
        duration: 0.5,
        delay: 0,
      });

      gsap.to(".c-block-hero--chapter3 h1", {
        scrollTrigger: {
          trigger: ".c-block-hero--chapter3 h1",
          start: "top 90%",
        },
        alpha: 1,
        x: 0,
        ease: "none",
        duration: 0.5,
      });
      gsap.to(".c-block-hero--chapter3 .o-rte-text", {
        scrollTrigger: {
          trigger: ".c-block-hero--chapter3 .o-rte-text",
          start: "top 90%",
        },
        alpha: 1,
        x: 0,
        ease: "none",
        duration: 0.5,
      });
      if (
        $(".c-block-hero--chapter3 .c-block-split__link-wrapper").length > 0
      ) {
        gsap.to(".c-block-hero--chapter3 .c-block-split__link-wrapper", {
          scrollTrigger: {
            trigger: ".c-block-hero--chapter3 .c-block-split__link-wrapper",
            start: "top 90%",
          },
          alpha: 1,
          y: 0,
          ease: "none",
          duration: 0.5,
          delay: 0,
        });
      }
      gsap.to(".c-block-hero--chapter3 img", {
        scrollTrigger: {
          trigger: ".c-block-hero--chapter3 img",
          start: "top 90%",
        },
        filter: "grayscale(0%)",
        "-webkit-filter": "grayscale(0%)",
        skewX: 0,
        ease: "none",
        duration: 0.5,
        delay: 0,
      });
    }

    /*
     * Toggle Mega menu for careers and about
     */
    
    if (window.innerWidth >= 768) {
      gsap.set(".c-menu-mega", { alpha: 0, y: "-100%", display: "block" });
      gsap.set(".c-menu-mega--careers__left", { alpha: 0, y: "-10%" });
      gsap.set(".c-menu-mega--careers__right", { alpha: 0, y: "-10%" });
      gsap.set(".c-menu-mega--about__section", { alpha: 0, y: "-10%" });
      const closeAboutMenu = () => {
        $("#js-menu__about_us .u-plus").removeClass("open");
        $("#js-menu-dropdown__about").removeClass("open");
        gsap.to("#js-menu-dropdown__about", {
          alpha: 0,
          y: "-100%",
          ease: "none",
          duration: 0.6,
        });
        gsap.utils
          .toArray(".c-menu-mega--about__section")
          .forEach((element, index) => {
            gsap.to(element, {
              alpha: 0,
              y: "-10%",
              ease: "none",
              duration: 0.1,
              delay: 0.4,
            });
          });
      };

      const openAboutMenu = () => {
        $("#js-menu__about_us .u-plus").addClass("open");
        gsap.to("#js-menu-dropdown__about", {
          alpha: 1,
          y: 0,
          ease: "none",
          duration: 0.6,
        });
        gsap.utils
          .toArray(".c-menu-mega--about__section")
          .forEach((element, index) => {
            gsap.to(element, {
              alpha: 1,
              y: 0,
              ease: "none",
              duration: 0.4,
              delay: 0.4,
            });
          });
      };

      const closeCareersMenu = () => {
        $("#js-menu-dropdown__careers").removeClass("open");
        $("#js-menu__careers .u-plus").removeClass("open");
        gsap.to("#js-menu-dropdown__careers", {
          alpha: 0,
          y: "-100%",
          ease: "none",
          duration: 0.6,
        });
        gsap.to(".c-menu-mega--careers__left", {
          alpha: 0,
          y: "-10%",
          ease: "none",
        });
        gsap.to(".c-menu-mega--careers__right", {
          alpha: 0,
          y: "-10%",
          ease: "none",
        });
      };

      const openCareersMenu = () => {
        $("#js-menu__careers .u-plus").addClass("open");
        gsap.to("#js-menu-dropdown__careers", {
          alpha: 1,
          y: 0,
          ease: "none",
          duration: 0.5,
        });
        gsap.to(".c-menu-mega--careers__left", {
          alpha: 1,
          y: 0,
          ease: "none",
          delay: 0.4,
        });
        gsap.to(".c-menu-mega--careers__right", {
          alpha: 1,
          y: 0,
          ease: "none",
          delay: 0.4,
        });
      };

      $("#js-menu__careers").on("click", () => {
        if ($("#js-menu-dropdown__about").hasClass("open")) {
          closeAboutMenu();
        }
        // if($('.c-main-header').hasClass('dark')) {
        //   $('.c-main-header').toggleClass('u-reversed-out');
        //   $('.c-main-header').toggleClass('u-reversed-out--blue');
        // }

        if ($("#js-menu-dropdown__careers").hasClass("open")) {
          closeCareersMenu();
        } else {
          $("#js-menu-dropdown__careers").addClass("open");
          if ($("#js-menu-dropdown__about").hasClass("open")) {
            closeAboutMenu();
          }
          openCareersMenu();
        }

        if (
          $("#js-menu-dropdown__about").hasClass("open") ||
          $("#js-menu-dropdown__careers").hasClass("open")
        ) {
          $(".c-main-header").removeClass("u-reversed-out--blue");
          $(".c-main-header").removeClass("u-reversed-out");
          $(".u-catcher").addClass("open");
        } else {
          if ($(".c-main-header").hasClass("dark")) {
            $(".c-main-header").addClass("u-reversed-out--blue");
            $(".c-main-header").addClass("u-reversed-out");
          }
          $(".u-catcher").removeClass("open");
        }
      });

      $("#js-menu__about_us").on("click", () => {
        if ($("#js-menu-dropdown__careers").hasClass("open")) {
          closeCareersMenu();
        }

        // if($('.c-main-header').hasClass('dark')) {
        //   $('.c-main-header').toggleClass('u-reversed-out');
        //   $('.c-main-header').toggleClass('u-reversed-out--blue');
        // }

        if ($("#js-menu-dropdown__about").hasClass("open")) {
          closeAboutMenu();
        } else {
          $("#js-menu-dropdown__about").addClass("open");
          if ($("#js-menu-dropdown__careers").hasClass("open")) {
            closeCareersMenu();
          }
          openAboutMenu();
        }
        if (
          $("#js-menu-dropdown__about").hasClass("open") ||
          $("#js-menu-dropdown__careers").hasClass("open")
        ) {
          $(".u-catcher").addClass("open");
          $(".c-main-header").removeClass("u-reversed-out--blue");
          $(".c-main-header").removeClass("u-reversed-out");
        } else {
          if ($(".c-main-header").hasClass("dark")) {
            $(".c-main-header").addClass("u-reversed-out--blue");
            $(".c-main-header").addClass("u-reversed-out");
          }
          $(".u-catcher").removeClass("open");
        }
      });

      $(".u-catcher").on("click", () => {
        $(".u-catcher").removeClass("open");
        if ($(".c-main-header").hasClass("dark")) {
          $(".c-main-header").toggleClass("u-reversed-out");
          $(".c-main-header").toggleClass("u-reversed-out--blue");
        }
        if ($("#js-menu-dropdown__about").hasClass("open")) {
          closeAboutMenu();
        }
        if ($("#js-menu-dropdown__careers").hasClass("open")) {
          closeCareersMenu();
        }
      });

      // Media Query Listener
      let lastKnownMedia = window.innerWidth;

      function mediaQueryCheck(query) {
        let currentWidth = window.innerWidth;

        if (currentWidth < lastKnownMedia) {
          if (query.matches) {
            closeAboutMenu();
            closeCareersMenu();
          }  
        } 
        // else if (currentWidth > lastKnownMedia) {
        //   if (!query.matches && mobileNavActive) {
        //     mobileNav.classList.remove('active');
        //     header.classList.remove('active');
        //     mobileNavActive = false;
        //   }  
        // }

        lastKnownMedia = currentWidth;
      }

      // Create a MediaQueryList object
      let queryMatch = window.matchMedia("(max-width: 768px)")

      // Attach listener function on state changes
      queryMatch.addEventListener("change", function() {
        mediaQueryCheck(queryMatch);
      });
    }

    if (
      $(".c-block-side-by-side__section--right").length > 0 ||
      $(".c-block-side-by-side__section--left").length > 0
    ) {
      if (window.innerWidth < 850) {
        gsap.set(".c-block-side-by-side__section--right", { x: 0 });
        gsap.set(".c-block-side-by-side__section--left", { x: 0 });
        gsap.set(".c-block-side-by-side--right", { x: 0 });
        $(".js-open-right").on("click", () => {
          gsap.to(".c-block-side-by-side", {
            height: $(".c-block-side-by-side--right").height() + 80,
            ease: "power2.out",
            duration: 1,
          });
          gsap.to(".c-block-side-by-side__section--right", {
            alpha: 0,
            y: "100%",
            ease: "power2.out",
            duration: 1,
          });
          gsap.to(".c-block-side-by-side__section--left", {
            alpha: 0,
            y: "-100%",
            ease: "power2.out",
            duration: 1,
          });
          gsap.to(".c-block-side-by-side--right", {
            alpha: 1,
            zIndex: 1,
            ease: "power2.out",
            duration: 1,
          });
        });

        $(".js-open-left").on("click", () => {
          gsap.to(".c-block-side-by-side", {
            height: $(".c-block-side-by-side--left").height() + 80,
            ease: "power2.out",
            duration: 1,
          });
          gsap.to(".c-block-side-by-side__section--right", {
            alpha: 0,
            y: "100%",
            ease: "power2.out",
            duration: 1,
          });
          gsap.to(".c-block-side-by-side__section--left", {
            alpha: 0,
            y: "-100%",
            ease: "power2.out",
            duration: 1,
          });
          gsap.to(".c-block-side-by-side--left", {
            alpha: 1,
            zIndex: 1,
            ease: "power2.out",
            duration: 1,
          });
        });

        $(".js-close-modal").on("click", (e) => {
          e.preventDefault();
          gsap.to(".c-block-side-by-side", {
            height: "auto",
            ease: "power2.out",
            duration: 1,
          });
          gsap.to(".c-block-side-by-side__section--right", {
            alpha: 1,
            y: 0,
            x: 0,
            zIndex: 1,
            ease: "power2.out",
            duration: 1,
          });
          gsap.to(".c-block-side-by-side__section--left", {
            alpha: 1,
            y: 0,
            x: 0,
            zIndex: 1,
            ease: "power2.out",
            duration: 1,
          });
          gsap.to(".c-block-side-by-side--left", {
            alpha: 0,
            zIndex: -1,
            ease: "power2.out",
            duration: 1.4,
          });
          gsap.to(".c-block-side-by-side--right", {
            alpha: 0,
            zIndex: -1,
            ease: "power2.out",
            duration: 1.4,
          });
        });
      } else {
        gsap.set(".c-block-side-by-side__section--right", { y: 0 });
        gsap.set(".c-block-side-by-side__section--left", { y: 0 });
        $(".js-open-right").on("click", () => {
          gsap.to(".c-block-side-by-side__section--right", {
            alpha: 0,
            x: "100%",
            ease: "power2.out",
            duration: 1,
          });
          gsap.to(".c-block-side-by-side__section--left", {
            alpha: 0,
            x: "-100%",
            ease: "power2.out",
            duration: 1,
          });
          gsap.to(".c-block-side-by-side--right", {
            alpha: 1,
            zIndex: 1,
            ease: "power2.out",
            duration: 1,
          });
        });

        $(".js-open-left").on("click", () => {
          gsap.to(".c-block-side-by-side__section--right", {
            alpha: 0,
            x: "100%",
            ease: "power2.out",
            duration: 1,
          });
          gsap.to(".c-block-side-by-side__section--left", {
            alpha: 0,
            x: "-100%",
            ease: "power2.out",
            duration: 1,
          });
          gsap.to(".c-block-side-by-side--left", {
            alpha: 1,
            zIndex: 1,
            ease: "power2.out",
            duration: 1,
          });
        });

        $(".js-close-modal").on("click", (e) => {
          e.preventDefault();
          gsap.to(".c-block-side-by-side__section--right", {
            alpha: 1,
            x: 0,
            ease: "power2.out",
            duration: 1,
          });
          gsap.to(".c-block-side-by-side__section--left", {
            alpha: 1,
            x: 0,
            ease: "power2.out",
            duration: 1,
          });
          gsap.to(".c-block-side-by-side--left", {
            alpha: 0.1,
            zIndex: 0,
            ease: "power2.out",
            duration: 1.4,
          });
          gsap.to(".c-block-side-by-side--right", {
            alpha: 0.1,
            zIndex: 0,
            ease: "power2.out",
            duration: 1.4,
          });
        });
      }
    }
    $(".swiper")
      .parent()
      .parent(".l-container")
      .css({ position: "static", maxWidth: "100%", padding: "0" });
    Swiper.use([Navigation]);
    const swiper = new Swiper(".swiper", {
      // Optional parameters
      slidesPerView: 1,
      // slidesPerGroup: 1,
      spaceBetween: "-10%",
      breakpoints: {
        640: {
          slidesPerView: 2,
          // slidesPerGroup: 2,
        },
        768: {
          slidesPerView: 3,
          // slidesPerGroup: 3,
        },
        1024: {
          slidesPerView: 4,
          // slidesPerGroup: 4,
        },
        1200: {
          slidesPerView: 5,
          // slidesPerGroup: 5,
        },
      },
      direction: "horizontal",
      freeMode: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

    /*
     * figcaption color based on the following div it overlays
     */
    if (
      $(".c-main-document article:nth-child(2)").hasClass(
        "u-background--dk-blue"
      ) ||
      $(".c-main-document article:nth-child(2)").hasClass("u-background--green")
    ) {
      $(".c-main-document article:nth-child(1)")
        .find("figcaption")
        .addClass("u-color--white");
    }

    /*
     * Modal Form
     */

    $(".o-button--form").on("click", function (e) {
      $(".u-catcher").addClass("open");
      e.preventDefault();
      $(this).next(".c-modal").fadeIn(500);
      $(this)
        .next(".c-modal")
        .find(".c-modal__content")
        .removeClass("is-closed");
      //$("body").css("overflow", "hidden", "width", "100vw");
      if ($(document).height() > $(window).height()) {
        var scrollTop = ($('html').scrollTop()) ? $('html').scrollTop() : $('body').scrollTop(); // Works for Chrome, Firefox, IE...
        $('html').addClass('noscroll').css('top',-scrollTop);
      }
    });

    $(".c-modal__close").on("click", function (e) {
      e.preventDefault();
      $(".u-catcher").removeClass("open");
      $(this).parent(".c-modal__content").addClass("is-closed");
      $(this).parents(".c-modal").fadeOut(1000);
      //$("body").css("overflow", "unset");
      var scrollTop = parseInt($('html').css('top'));
      $('html').removeClass('noscroll');
      $('html,body').scrollTop(-scrollTop);
    });

    $(".u-catcher").on("click", function (e) {
      $(".u-catcher").removeClass("open");
      $(".c-modal__content").addClass("is-closed");
      $(".c-modal").fadeOut(1000);
      //$("body").css("overflow", "unset");
      var scrollTop = parseInt($('html').css('top'));
      $('html').removeClass('noscroll');
      $('html,body').scrollTop(-scrollTop);
    });

    /*
     * Filter on the Perspectives page (blog page)
     */
    var container = $("#container");

    function setLazyLoad() {
      container.find("img").lazyload({
        event: "turnPage",
        effect: "fadeIn",
      });
    }
    setLazyLoad();

    const isoOptions = {
      itemSelector: ".filter-container > section",
      layoutMode: "masonry",
      hiddenStyle: {
        opacity: 0
      },
      visibleStyle: {
        opacity: 1
      },
      masonry: {
        gutter: 40,
      },
    }
    window.addEventListener('resize', () => {
        filterContainer.isotope('destroy'); // destroy
        filterContainer.isotope( isoOptions ); // re-initialize
    });

    const filterContainer = $(".filter-container");

    filterContainer.isotope( isoOptions );

    const ft = $.filtrify("container", "placeholder", {
      close: true,
      callback: function (mismatch, match, query) {
        match.slice(0,8).forEach(item => {
          item.classList.remove("ft-hidden");
          item.classList.remove("u-display--none")
        });
        container.isotope({ filter: $(match) });
        $('.u-load-more').show();
        if (mismatch.category.length == 0) {
          $("#reset").addClass("ft-hidden");
        }
      },
    });

    //$("#reset").hide();
    if ($(".filter-container").length > 0) {
      ft.trigger({ category: [] });
      $("#reset").on("click", function () {
        ft.reset();
      });
    }


    // Load more functionality - Perspectives blog page (P72 site)
    $('.u-load-more').on('click', () => {
      const activeCategory = $('.ft-label')[0].innerText;
      $(".u-display--none").not('.ft-hidden').slice(0,8).removeClass("u-display--none");
      if (activeCategory == 'category' || activeCategory == 'All') {
        ft.trigger({ category: [] });
        setTimeout(() => {
          $('.ft-tags #reset').addClass('ft-hidden');
        }, 100);
        if ($(".u-display--none").length === 0) {
          $('.u-load-more').hide();
        }else {
          $('.u-load-more').show();
        }
      }else  {
        ft.trigger({ category: [activeCategory] });
        if (`${$(".l-article--post ").not(".u-display--none").not('.ft-hidden').length - 1}` === $('.ft-selected li')[0].dataset.count) {
          $('.u-load-more').hide();
        }else {
          $('.u-load-more').show();
        }
      }
    });

    const scrollAnimations = gsap.utils.toArray(".u-scroll-animation");

    scrollAnimations.forEach((section) => {
      ScrollTrigger.create({
        trigger: section,
        start: "top 90%",
        onEnter: () => $(section).addClass("u-scroll-animate"),
        //markers: true,
      });
    });

    const explodeImages = document.querySelectorAll('.explode')
    var throttle = function(type, name, obj) {
      var obj = obj || window;
      var running = false;
      var func = function() {
          if (running) { return; }
          running = true;
          requestAnimationFrame(function() {
              obj.dispatchEvent(new CustomEvent(name));
              running = false;
          });
      };
      obj.addEventListener(type, func);
  };

  if (explodeImages.length > 0) {
    throttle ("scroll", "optimizedScroll");
      window.addEventListener("scroll", function(e) {
        e.preventDefault();
        explodeImages[0].style.transform = "translateX(50%) rotate("+(window.pageYOffset*0.05)+"deg)";
        //explodeImages[1].style.transform = "rotate("+(window.pageYOffset*0.05)+"deg)";
    });
  };

    // add class to homepage hero block split to avoid override of default animations
    $(".o-hero__chapter").find(".l-container").addClass("c-block--homepage");

  },

};



// WEBPACK FOOTER //
// ./scripts/routes/common.js